<mat-list-item [class.expand]="isExpanded">
  <ds-lib-search-autocomplete
    class="byd-search-autocomplete"
    *ngIf="isExpanded; else dropdownSelectIcon"
    [options]="_tab.selectItems"
    [selectedControl]="selectedControl"
    (selectEmitter)="selectChange()"
    (openedEmitter)="opened = $event"
    [position]="{ top: '30px', left: '5px' }"
    [placeholder]="'dsLibCommon.general.selectSearch' | translate"
    width="275"
  >
    <div class="autocomplete-trigger">
      <span>
        {{ selectedControl.value?.name || ('dsLibCommon.general.select' | translate) }}
      </span>
      <mat-icon *ngIf="opened; else closedArrow">arrow_drop_down</mat-icon>
      <ng-template #closedArrow>
        <mat-icon>arrow_right</mat-icon>
      </ng-template>
    </div>
  </ds-lib-search-autocomplete>
  <ng-template #dropdownSelectIcon>
    <mat-icon class="dropdown-select-icon" (click)="onDropdownIconClicked()">storage</mat-icon>
  </ng-template>
</mat-list-item>
